export { default as SvgVisa } from './SvgVisa';
export { default as SvgApplePay } from './SvgApplePay';
export { default as SvgAmex } from './SvgAmex';
export { default as SvgGooglePay } from './SvgGooglePay';
export { default as SvgMasterCard } from './SvgMasterCard';
export { default as SvgCardPlaceholder } from './SvgCardPlaceholder';
export { default as SvgCardPlaceholderGrey } from './SvgCardPlaceholderGrey';
export { default as SvgPaymentMethod } from './SvgPaymentMethod';
//# sourceMappingURL=index.js.map